import { query_product_out_record_list } from '@/api/mjstock-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '出库单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写出库单编号',
    },
    {
      type: 'remotemodal',
      name: 's_product_id',
      label: '存货名称',
      disabled: false,
      placeholder: '请选择存货名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstock-sproduct',
    },
    {
      type: 'remoteselect',
      name: 'order_used_record_id',
      label: '关联耗单',
      disabled: false,
      placeholder: '请选择关联耗单',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-orderusedrecord',
    },
    {
      type: 'remotemodal',
      name: 'product_in_record_id',
      label: '关联入库单',
      disabled: false,
      placeholder: '请选择关联入库单',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstock-productinrecord',
    },
    {
      type: 'remotemodal',
      name: 'to_shop_id',
      label: '调拨去向',
      disabled: false,
      placeholder: '请选择调拨去向',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'input',
      name: 'transfer_code',
      label: '调拨编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写调拨编号',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    code: null,
    s_product_id: null,
    order_used_record_id: null,
    product_in_record_id: null,
    out_type: null,
    to_shop_id: null,
    transfer_code: null,
    shop_id: null,
    staff_id: null,
  }),
};
const search_options = {
  out_type: [
    { value: None, name: '全部' },
    { value: 1, name: '销售出库' },
    { value: 2, name: '盘亏出库' },
    { value: 3, name: '调拨出库' },
    { value: 4, name: '员工福利' },
    { value: 5, name: '客户试用' },
    { value: 6, name: '其他出库' },
  ],
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: 'ID',
    width: 150,
    dataIndex: 'id',
    fixed: false,
    checked: false,
  },
  {
    title: '出库类型',
    width: 150,
    dataIndex: 'out_type',
    fixed: false,
    checked: true,
  },
  {
    title: '出库编号',
    width: 150,
    dataIndex: 'code',
    fixed: false,
    checked: true,
  },
  {
    title: '存货编号',
    width: 150,
    dataIndex: 's_product__code',
    fixed: false,
    checked: true,
  },
  {
    title: '存货名称',
    width: 150,
    dataIndex: 's_product__name',
    fixed: false,
    checked: true,
  },

  {
    title: '关联耗单',
    width: 150,
    dataIndex: 'order_used_record_id',
    fixed: false,
    checked: true,
  },
  {
    title: '关联入库单',
    width: 150,
    dataIndex: 'product_in_record_id',
    fixed: false,
    checked: true,
  },
  {
    title: '关联入库单编号',
    width: 150,
    dataIndex: 'product_in_record__code',
    fixed: false,
    checked: true,
  },
  {
    title: '出库数量',
    width: 150,
    dataIndex: 'out_num',
    fixed: false,
    checked: true,
  },
  {
    title: '存货单价',
    width: 150,
    dataIndex: 'single_price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '存货金额',
    width: 150,
    dataIndex: 'price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '调拨去向',
    width: 150,
    dataIndex: 'to_shop__name',
    fixed: false,
    checked: true,
  },
  {
    title: '调拨编号',
    width: 150,
    dataIndex: 'to_shop__code',
    fixed: false,
    checked: true,
  },
  {
    title: '调拨编号',
    width: 150,
    dataIndex: 'transfer_code',
    fixed: false,
    checked: true,
  },
  {
    title: '出库日期',
    width: 150,
    dataIndex: 'out_datetime',
    fixed: false,
    checked: true,
  },
  {
    title: '执行门店',
    width: 150,
    dataIndex: 'shop__name',
    fixed: false,
    checked: true,
  },
  {
    title: '执行人',
    width: 150,
    dataIndex: 'staff__name',
    fixed: false,
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    fixed: false,
    checked: true,
  },

  {
    title: '单据状态',
    width: 150,
    dataIndex: 'is_active',
    fixed: false,
    checked: true,
  },
];

export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_product_out_record_list,
    columns: columns,
    slotList: defaultSlotList,
  };
};
